import { Injector } from '@angular/core';
import { ResultItem } from 'src/app/apiAndObjects/objects/resultItems/resultItem.interface';
import { BgsLeafletComponent, FeatureDisplayItem, LayerClickManager } from 'src/app/bgsLeaflet/public_api';
import { EVResultsService } from '../ev-sidebar-results/ev-sidebar-results.service';
import { EVMapService } from './ev-map.service';

export class EvLayerClickManager extends LayerClickManager {
  private readonly resultsService: EVResultsService;
  private readonly mapService: EVMapService;

  constructor(injector: Injector) {
    super();
    this.resultsService = injector.get<EVResultsService>(EVResultsService);
    this.mapService = injector.get<EVMapService>(EVMapService);
  }

  public click(clickEvent: L.LeafletMouseEvent, bgsLeaflet: BgsLeafletComponent): void {
    // if we're placing a pin
    if (this.mapService.placingPin) {
      this.mapService.setPlacedPinPosition(clickEvent.latlng);
    } else {
      // normal click so show feature details
      super.click(clickEvent, bgsLeaflet);
    }
  }

  public displayFeatures(featureItemsPromise: Promise<Array<FeatureDisplayItem>>): void {
    featureItemsPromise.then((items: Array<FeatureDisplayItem>) => {
      if (!items || items.length === 0) {
        return;
      }
      // Prevent objects being passed to display if contain null featuresß
      if (!items[0].featureObject) {
        return;
      } else {
        this.resultsService.setResults(items.map((item) => item.featureObject) as Array<ResultItem>);
      }
    });
  }
}
